// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-slider-UDGH2F{-moz-column-gap:8px;align-items:flex-start;column-gap:8px;display:flex}.input-slider-UDGH2F .semi-slider{flex:1}.input-slider-UDGH2F .slider-HI0YKE{width:100%}.input-slider-UDGH2F .input-number-ydmXuc{width:120px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-slider": `input-slider-UDGH2F`,
	"inputSlider": `input-slider-UDGH2F`,
	"slider": `slider-HI0YKE`,
	"input-number": `input-number-ydmXuc`,
	"inputNumber": `input-number-ydmXuc`
};
export default ___CSS_LOADER_EXPORT___;
